import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetMentorAvailabilityResponse } from '@edtech-ui/core/models/mentors-sessions/available-slots-time-session';
import { GetAllMentorResponse } from '@edtech-ui/core/models/mentors-sessions/get-all-mentors';
import { MentorSessionDurationPricingResponse, MentorSessionPricingRequest } from '@edtech-ui/core/models/mentors-sessions/get-all-prices';
import { GoogleCalenderAuthCallBackResponse, GoogleCalenderAuthUrlResponse } from '@edtech-ui/core/models/mentors-sessions/get-google-calander-auth-callback';
import { GetMentorUpcomingBookingResponse } from '@edtech-ui/core/models/mentors-sessions/get-mentor-upcoming-session';
import { MentorSessionRefreshTokenResponse } from '@edtech-ui/core/models/mentors-sessions/google-calander-refresh-token';
import { MentorBookingPayload, MentorSessionBookingData, MentorSessionBookingResponse } from '@edtech-ui/core/models/mentors-sessions/post-booking-session';
import { PostMentorCancelBookingResponse } from '@edtech-ui/core/models/mentors-sessions/post-cancel-booking';
import { MentorSessionBookingPayload, MentorSessionBookingReserveSlotResponse } from '@edtech-ui/core/models/mentors-sessions/post-confirm-reserve-slots';
import { MentorRefundPaymnetResponse } from '@edtech-ui/core/models/mentors-sessions/post-refund-payment';
import { GetAppointmentTypesResponse } from '@edtech-ui/core/models/mentors-sessions/types-of-sessions';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class MentorService {

	apiUrl = environment.mentorApiUrl;

	mentorBookingId = new BehaviorSubject<string>('');
	studentName = new BehaviorSubject<string>('');
	saveConfirmBookingData = new BehaviorSubject<MentorSessionBookingData | null>(null);

	constructor(private http: HttpClient) { }

	getAllMentors(page: number = 1, limit: number = 10): Observable<GetAllMentorResponse> {
		const params = new HttpParams().set('page', page).set('limit', limit)
		return this.http.get<GetAllMentorResponse>(`${this.apiUrl}/mentors`, { params });
	}

	getUsersSessionsType(page: number = 1, limit: number = 10): Observable<GetAppointmentTypesResponse> {
		const params = new HttpParams().set('page', page).set('limit', limit)
		return this.http.get<GetAppointmentTypesResponse>(`${this.apiUrl}/appointment-types`, { params });
	}

	getAllAvailableTimeSlots(mentorId: string, availableDate: string, durationMinute: number): Observable<GetMentorAvailabilityResponse> {
		const params = new HttpParams().set('available_date', availableDate).set('duration_minutes', durationMinute)
		return this.http.get<GetMentorAvailabilityResponse>(`${this.apiUrl}/mentors/${mentorId}/available-slots`, { params })
	}

	postMentorSession(payload: MentorBookingPayload): Observable<MentorSessionBookingResponse> {
		return this.http.post<MentorSessionBookingResponse>(`${this.apiUrl}/bookings/confirm`, payload);
	}

	getUpcomingMentorSession(pageNo: number = 1, pageLimit: number = 10): Observable<GetMentorUpcomingBookingResponse> {
		const params = new HttpParams().set('page', pageNo).set('limit', pageLimit)
		return this.http.get<GetMentorUpcomingBookingResponse>(`${this.apiUrl}/bookings/upcoming`, { params })
	}

	deleteBookingForm(bookingId: string, cancelReason: string): Observable<PostMentorCancelBookingResponse> {
		const params = new HttpParams().set('cancel_reason', cancelReason);
		return this.http.post<PostMentorCancelBookingResponse>(`${this.apiUrl}/bookings/${bookingId}/cancel`, null, { params })
	}

	putReScheduleBooking(bookingId: string, payload: any): Observable<any> {
		return this.http.put<any>(`${this.apiUrl}/bookings/${bookingId}/reschedule`, { payload })
	}

	getMentorSessionPricing(request: MentorSessionPricingRequest): Observable<MentorSessionDurationPricingResponse> {
		let params = new HttpParams()
			.set('appointment_type_id', request.appointment_type_id)
			.set('mentor_id', request.mentor_id);
		if (request.currency) {
			params = params.set('currency', request.currency);
		}
		return this.http.get<MentorSessionDurationPricingResponse>(`${this.apiUrl}/duration-pricing`, { params })
	}

	getGoogleCalenderAuthUrl(redirectUrl: string): Observable<GoogleCalenderAuthUrlResponse> {
		const params = new HttpParams().set('redirect_uri', redirectUrl)
		return this.http.get<GoogleCalenderAuthUrlResponse>(`${this.apiUrl}/auth-url`, { params });
	}

	getGoogleCalenderAuthCallBack(googleCode: string, redirectUrl: string): Observable<GoogleCalenderAuthCallBackResponse> {
		const params = new HttpParams().set('code', googleCode).set('redirect_uri', redirectUrl)
		return this.http.get<GoogleCalenderAuthCallBackResponse>(`${this.apiUrl}/calendar/callback`, { params });
	}

	postMentorSessionRefreshToken(): Observable<MentorSessionRefreshTokenResponse> {
		return this.http.post<MentorSessionRefreshTokenResponse>(`${this.apiUrl}/refresh-access-token`, {});
	}

	postMentorSessionReserveSlot(payload: MentorSessionBookingPayload): Observable<MentorSessionBookingReserveSlotResponse> {
		return this.http.post<MentorSessionBookingReserveSlotResponse>(`${this.apiUrl}/bookings/reserve`, payload);
	}

	getAllMentorSessionHistory(pageNo: number = 1, pageLimit: number = 10): Observable<GetMentorUpcomingBookingResponse> {
		const params = new HttpParams().set('page', pageNo).set('limit', pageLimit)
		return this.http.get<GetMentorUpcomingBookingResponse>(`${this.apiUrl}/bookings/history`, { params })
	}

	postRefundpayment(bookingId: string): Observable<MentorRefundPaymnetResponse> {
		return this.http.post<MentorRefundPaymnetResponse>(`${this.apiUrl}/bookings/${bookingId}/refund`, bookingId);
	}

	getMentorCancelledRefund(pageNo: number = 1, pageLimit: number = 10): Observable<GetMentorUpcomingBookingResponse> {
		const params = new HttpParams().set('page', pageNo).set('limit', pageLimit)
		return this.http.get<GetMentorUpcomingBookingResponse>(`${this.apiUrl}/bookings/cancelled`, { params })
	}

}